import { Box, VStack } from "@chakra-ui/react";

import { useDocumentTitle } from "@equidefi/portals/hooks/useDocumentTitle";
import { Heading, Text } from "@equidefi/ui";
import { useSavedProfiles } from "@equidefi/portals/hooks/useSavedProfiles";

import { VaultContainer, ProfileNavButton, SavedProfileCard } from "@/pages/app/vault/v2/components";

const SavedProfiles = () => {
  useDocumentTitle(["Saved Profiles"]);

  const { data: savedProfiles = [], isLoading } = useSavedProfiles({ refetchOnMount: "always" });

  return (
    <VaultContainer>
      <VStack align="stretch" spacing="4" w="full">
        <ProfileNavButton to="/vault/profile" layout="rtl">
          Back To Account
        </ProfileNavButton>

        <Box
          bg="white"
          borderRadius="lg"
          p="4"
          boxShadow="0 1px 2px rgba(0, 0, 0, 0.2)"
          border="1px solid"
          borderColor="gray.100">
          <Heading as="h1" fontSize="24px" lineHeight="28px" fontWeight="700" mb="4">
            Saved Profiles
          </Heading>

          <Text m="0" fontSize="17px" lineHeight="26px">
            A saved profile is a set of saved information that you can reuse on future investments.
          </Text>
        </Box>

        {savedProfiles.length === 0 ? (
          <SavedProfilesEmpty />
        ) : (
          <VStack align="stretch" spacing="4">
            {savedProfiles.map((profile) => (
              <SavedProfileCard key={profile.id} profile={profile} />
            ))}
          </VStack>
        )}
      </VStack>
    </VaultContainer>
  );
};

const SavedProfilesEmpty = () => {
  return (
    <Box pt="4" textAlign="center">
      <Text m="0" color="#657797" fontSize="17px" lineHeight="24px">
        You don’t have any saved profiles yet.
      </Text>
    </Box>
  );
};

export default SavedProfiles;
